<template>
	<div>
		<div id="main" style="width: 90%;height:400px;margin: 0 auto"></div>
		<div id="main2" style="width: 90%;height:400px;margin: 0 auto"></div>
		<div id="main3" style="width: 90%;height:650px;margin: 0 auto;"></div>

	</div>
</template>
<script>
export default {
	props: ["stu_from_type"],
	name: 'dataview',
	data() {
		return {}
	},
	mounted() {
		this.getList()
	},
	methods: {
		getList() {
			this.$http.post("/api/students_pre_data", {
				stu_from_type: this.stu_from_type,
				status: this.$store.state.pmid == 6 ? 1 : 0
			}).then(res => {
				let data = res.data
				console.log(res.data)
				this.draw('main', data.citys);
				this.draw2('main2', data.nianzhi);
				this.draw3('main3', data.majors);

			})
		},
		draw(chart, data) {

			console.log(data)
			let ndata = [];
			let waishi = {
				name: "外市",
				value: 0
			}
			for (let item of data) {
				if (item.name == "南京市") {
					ndata.push(item)
				} else {
					waishi.value += item.value
				}

			}
			ndata.push(waishi)
			data = ndata



			let xLabels = [],
				xValues = [],
				total = 0,
				subtext = '总人数：0人'
			if (data && data.length > 0) {
				xLabels = data.map(obj => {
					return obj.name;
				})
				xValues = data.map(obj => {
					return obj.value;
				})
				total = eval(xValues.join("+"));
				subtext = `总人数：${total}人`
			}
			let _this = this
			let myChart = this.$echarts.init(document.getElementById(chart))
			myChart.clear();
			myChart.showLoading();
			let option = {
				// ----  标题 -----
				title: {
					text: '地区',
					textStyle: {
						color: '#333'
					},
					subtext: subtext,
					subtextStyle: {
						color: '#1890ff'
					},
					padding: [0, 0, 10, 20] // 位置
				},
				// ---  提示框 ----
				tooltip: {
					show: true, // 是否显示提示框，默认为true
					trigger: 'item', // 数据项图形触发
					axisPointer: { // 指示样式
						type: 'shadow',
						axis: 'auto'
					},
					padding: 5,
					textStyle: { // 提示框内容的样式
						color: '#fff'
					}
				},
				// ---- gird区域 ---
				gird: {
					show: false, // 是否显示直角坐标系网格
					top: 80, // 相对位置 top\bottom\left\right
					containLabel: false, // gird 区域是否包含坐标轴的刻度标签
					tooltip: {
						show: true,
						trigger: 'item', // 触发类型
						textStyle: {
							color: '#666'
						}
					}
				},
				//  ------  X轴 ------
				xAxis: {
					show: true, // 是否显示
					position: 'bottom', // x轴的位置
					offset: 0, // x轴相对于默认位置的偏移
					type: 'category', // 轴类型， 默认为 'category'
					name: '地区', // 轴名称
					nameLocation: 'end', // 轴名称相对位置
					nameTextStyle: { // 坐标轴名称样式
						color: '#333',
						padding: [5, 0, 0, -5]
					},
					nameGap: 15, // 坐标轴名称与轴线之间的距离
					nameRotate: 0, // 坐标轴名字旋转
					axisLine: { // 坐标轴 轴线
						show: true, // 是否显示
						symbol: ['none', 'arrow'], // 是否显示轴线箭头
						symbolSize: [8, 8], // 箭头大小
						symbolOffset: [0, 7], // 箭头位置
						// ------   线 ---------
						lineStyle: {
							color: '#1890ff',
							width: 1,
							type: 'solid'
						}
					},
					axisTick: { // 坐标轴 刻度
						show: true, // 是否显示
						inside: true, // 是否朝内
						length: 3, // 长度
						lineStyle: { // 默认取轴线的样式
							color: '#333',
							width: 1,
							type: 'solid'
						}
					},
					axisLabel: { // 坐标轴标签
						show: true, // 是否显示
						inside: false, // 是否朝内
						rotate: 45, // 旋转角度
						margin: 5, // 刻度标签与轴线之间的距离
						color: '#333' // 默认取轴线的颜色
					},
					splitLine: { // gird区域中的分割线
						show: false, // 是否显示
						lineStyle: {
							// color: 'red',
							// width: 1,
							// type: 'solid'
						}
					},
					splitArea: { // 网格区域
						show: false // 是否显示，默认为false
					},
					data: xLabels
				},
				//   ------   y轴  ----------
				yAxis: {
					show: true, // 是否显示
					position: 'left', // y轴位置
					offset: 0, // y轴相对于默认位置的偏移
					type: 'value', // 轴类型，默认为 ‘category’
					name: '人数', // 轴名称
					nameLocation: 'end', // 轴名称相对位置value
					nameTextStyle: { // 坐标轴名称样式
						color: '#fff',
						padding: [5, 0, 0, 5] // 坐标轴名称相对位置
					},
					nameGap: 15, // 坐标轴名称与轴线之间的距离
					nameRotate: 270, // 坐标轴名字旋转

					axisLine: { // 坐标轴 轴线
						show: true, // 是否显示
						//  -----   箭头 -----
						symbol: ['none', 'arrow'], // 是否显示轴线箭头
						symbolSize: [8, 8], // 箭头大小
						symbolOffset: [0, 7], // 箭头位置

						// ----- 线 -------
						lineStyle: {
							color: '#1890ff',
							width: 1,
							type: 'solid'
						}
					},
					axisTick: { // 坐标轴的刻度
						show: true, // 是否显示
						inside: true, // 是否朝内
						length: 3, // 长度
						lineStyle: {
							color: '#333', // 默认取轴线的颜色
							width: 1,
							type: 'solid'
						}
					},
					axisLabel: { // 坐标轴的标签
						show: true, // 是否显示
						inside: false, // 是否朝内
						rotate: 0, // 旋转角度
						margin: 8, // 刻度标签与轴线之间的距离
						color: '#333', // 默认轴线的颜色
					},
					splitLine: { // gird 区域中的分割线
						show: true, // 是否显示
						lineStyle: {
							color: '#666',
							width: 1,
							type: 'dashed'
						}
					},
					splitArea: { // 网格区域
						show: false // 是否显示，默认为false
					}
				},
				//  -------   内容数据 -------
				series: [{
					name: '人数', // 序列名称
					type: 'bar', // 类型
					legendHoverLink: true, // 是否启用图列 hover 时的联动高亮
					label: { // 图形上的文本标签
						show: false,
						position: 'insideTop', // 相对位置
						rotate: 0, // 旋转角度
						color: '#eee'
					},
					itemStyle: { // 图形的形状
						color: '#1890ff',
						barBorderRadius: [18, 18, 0, 0],
						normal: {
							label: {
								show: true, //开启显示
								position: 'top', //在上方显示
							},
							color: '#1890ff'

						}

					},
					barWidth: 20, // 柱形的宽度
					barCategoryGap: '20%', // 柱形的间距
					data: xValues
				}]
			};
			myChart.setOption(option)
			myChart.hideLoading();

		},
		draw2(chart, data) {
			let xLabels = [],
				xValues = [],
				total = 0,
				subtext = '总人数：0人'
			if (data && data.length > 0) {
				xLabels = data.map(obj => {
					return obj.name;
				})
				xValues = data.map(obj => {
					return obj.value;
				})
				total = eval(xValues.join("+"));
				subtext = `总人数：${total}人`
			}
			let _this = this
			let myChart = this.$echarts.init(document.getElementById(chart))
			myChart.clear();
			myChart.showLoading();
			let option = {
				// ----  标题 -----
				title: {
					text: '学制',
					textStyle: {
						color: '#333'
					},
					subtext: subtext,
					subtextStyle: {
						color: '#1890ff'
					},
					padding: [0, 0, 10, 20] // 位置
				},
				// ---  提示框 ----
				tooltip: {
					show: true, // 是否显示提示框，默认为true
					trigger: 'item', // 数据项图形触发
					axisPointer: { // 指示样式
						type: 'shadow',
						axis: 'auto'
					},
					padding: 5,
					textStyle: { // 提示框内容的样式
						color: '#fff'
					}
				},
				// ---- gird区域 ---
				gird: {
					show: false, // 是否显示直角坐标系网格
					top: 80, // 相对位置 top\bottom\left\right
					containLabel: false, // gird 区域是否包含坐标轴的刻度标签
					tooltip: {
						show: true,
						trigger: 'item', // 触发类型
						textStyle: {
							color: '#666'
						}
					}
				},
				//  ------  X轴 ------
				xAxis: {
					show: true, // 是否显示
					position: 'bottom', // x轴的位置
					offset: 0, // x轴相对于默认位置的偏移
					type: 'category', // 轴类型， 默认为 'category'
					name: '学制', // 轴名称
					nameLocation: 'end', // 轴名称相对位置
					nameTextStyle: { // 坐标轴名称样式
						color: '#333',
						padding: [5, 0, 0, -5]
					},
					nameGap: 15, // 坐标轴名称与轴线之间的距离
					nameRotate: 0, // 坐标轴名字旋转
					axisLine: { // 坐标轴 轴线
						show: true, // 是否显示
						symbol: ['none', 'arrow'], // 是否显示轴线箭头
						symbolSize: [8, 8], // 箭头大小
						symbolOffset: [0, 7], // 箭头位置
						// ------   线 ---------
						lineStyle: {
							color: '#1890ff',
							width: 1,
							type: 'solid'
						}
					},
					axisTick: { // 坐标轴 刻度
						show: true, // 是否显示
						inside: true, // 是否朝内
						length: 3, // 长度
						lineStyle: { // 默认取轴线的样式
							color: '#333',
							width: 1,
							type: 'solid'
						}
					},
					axisLabel: { // 坐标轴标签
						show: true, // 是否显示
						inside: false, // 是否朝内
						rotate: 0, // 旋转角度
						margin: 5, // 刻度标签与轴线之间的距离
						color: '#333' // 默认取轴线的颜色
					},
					splitLine: { // gird区域中的分割线
						show: false, // 是否显示
						lineStyle: {
							// color: 'red',
							// width: 1,
							// type: 'solid'
						}
					},
					splitArea: { // 网格区域
						show: false // 是否显示，默认为false
					},
					data: xLabels
				},
				//   ------   y轴  ----------
				yAxis: {
					show: true, // 是否显示
					position: 'left', // y轴位置
					offset: 0, // y轴相对于默认位置的偏移
					type: 'value', // 轴类型，默认为 ‘category’
					name: '人数', // 轴名称
					nameLocation: 'end', // 轴名称相对位置value
					nameTextStyle: { // 坐标轴名称样式
						color: '#fff',
						padding: [5, 0, 0, 5] // 坐标轴名称相对位置
					},
					nameGap: 15, // 坐标轴名称与轴线之间的距离
					nameRotate: 270, // 坐标轴名字旋转

					axisLine: { // 坐标轴 轴线
						show: true, // 是否显示
						//  -----   箭头 -----
						symbol: ['none', 'arrow'], // 是否显示轴线箭头
						symbolSize: [8, 8], // 箭头大小
						symbolOffset: [0, 7], // 箭头位置

						// ----- 线 -------
						lineStyle: {
							color: '#1890ff',
							width: 1,
							type: 'solid'
						}
					},
					axisTick: { // 坐标轴的刻度
						show: true, // 是否显示
						inside: true, // 是否朝内
						length: 3, // 长度
						lineStyle: {
							color: '#333', // 默认取轴线的颜色
							width: 1,
							type: 'solid'
						}
					},
					axisLabel: { // 坐标轴的标签
						show: true, // 是否显示
						inside: false, // 是否朝内
						rotate: 0, // 旋转角度
						margin: 8, // 刻度标签与轴线之间的距离
						color: '#333', // 默认轴线的颜色
					},
					splitLine: { // gird 区域中的分割线
						show: true, // 是否显示
						lineStyle: {
							color: '#666',
							width: 1,
							type: 'dashed'
						}
					},
					splitArea: { // 网格区域
						show: false // 是否显示，默认为false
					}
				},
				//  -------   内容数据 -------
				series: [{
					name: '人数', // 序列名称
					type: 'bar', // 类型
					legendHoverLink: true, // 是否启用图列 hover 时的联动高亮
					label: { // 图形上的文本标签
						show: false,
						position: 'insideTop', // 相对位置
						rotate: 0, // 旋转角度
						color: '#eee'
					},
					itemStyle: { // 图形的形状
						color: '#1890ff',
						barBorderRadius: [18, 18, 0, 0],
						normal: {
							label: {
								show: true, //开启显示
								position: 'top', //在上方显示
							},
							color: '#1890ff'

						}

					},
					barWidth: 20, // 柱形的宽度
					barCategoryGap: '20%', // 柱形的间距
					data: xValues
				}]
			};
			myChart.setOption(option)
			myChart.hideLoading();

		},
		draw3(chart, data) {
			let xLabels = [],
				xValues = [],
				total = 0,
				subtext = '总人数：0人'
			if (data && data.length > 0) {
				xLabels = data.map(obj => {
					return obj.name;
				})
				xValues = data.map(obj => {
					return obj.value;
				})
				total = eval(xValues.join("+"));
				subtext = `总人数：${total}人`
			}
			let _this = this
			let myChart = this.$echarts.init(document.getElementById(chart))
			let option = {
				grid: {

					bottom: 250
				},
				title: {
					text: '专业',
					textStyle: {
						color: '#333'
					},
					subtext: subtext,
					subtextStyle: {
						color: '#1890ff'
					},
					padding: [0, 0, 10, 20] // 位置
				},
				tooltip: {
					show: true, // 是否显示提示框，默认为true
					trigger: 'item', // 数据项图形触发
					axisPointer: { // 指示样式
						type: 'shadow',
						axis: 'auto'
					},
					padding: 5,
					textStyle: { // 提示框内容的样式
						color: '#fff'
					}
				},
				xAxis: {
					type: 'category',
					data: xLabels,
					name: '专业',
					nameTextStyle: { // 坐标轴名称样式
						color: '#333',
						padding: [5, 0, 0, -5]
					},
					axisLine: { // 坐标轴 轴线
						show: true, // 是否显示
						symbol: ['none', 'arrow'], // 是否显示轴线箭头
						symbolSize: [8, 8], // 箭头大小
						symbolOffset: [0, 7], // 箭头位置
						// ------   线 ---------
						lineStyle: {
							color: '#1890ff',
							width: 1,
							type: 'solid'
						}
					},
					axisLabel: {
						interval: 0,
						rotate: 45,
						color: '#333'
					}
				},
				yAxis: {
					type: 'value',
					axisLine: { // 坐标轴 轴线
						show: true, // 是否显示
						//  -----   箭头 -----
						symbol: ['none', 'arrow'], // 是否显示轴线箭头
						symbolSize: [8, 8], // 箭头大小
						symbolOffset: [0, 7], // 箭头位置

						// ----- 线 -------
						lineStyle: {
							color: '#1890ff',
							width: 1,
							type: 'solid'
						}
					},
					axisLabel: { // 坐标轴的标签
						margin: 8, // 刻度标签与轴线之间的距离
						color: '#333', // 默认轴线的颜色
					},
				},
				series: [{
					name: '人数',
					data: xValues,
					type: 'bar',
					itemStyle: { // 图形的形状
						color: '#1890ff',
						normal: {
							label: {
								show: true, //开启显示
								position: 'top', //在上方显示
							},
							color: '#1890ff'

						}

					},
				}]
			};
			myChart.setOption(option)

		},
	}
}
</script>
